// Ported from database-creator-main@e533337 frontend/src/wizard/erDiagram.js
// Changes: import paths only (../../components/Shared); otherwise verbatim — keep diffable.
// Builds a Mermaid erDiagram spec from the wizard's in-memory schema/key
// state — no backend round-trip needed, everything's already in React state
// by the time the user reaches the Download step. Names are sanitized for
// the diagram only (Mermaid identifiers can't contain arbitrary characters);
// the actual generated SQL already handles real names correctly via
// psycopg's identifier quoting, so this never needs to be byte-exact.

function sanitizeIdentifier(name, used) {
  let base = String(name).replace(/[^A-Za-z0-9_]/g, "_");
  if (!base || /^[0-9]/.test(base)) base = `_${base}`;
  let candidate = base;
  let n = 1;
  while (used.has(candidate)) candidate = `${base}_${n++}`;
  used.add(candidate);
  return candidate;
}

export function buildErDiagram(schemaTables, primaryKeys, foreignKeys) {
  const tableNames = Object.keys(schemaTables || {});
  if (tableNames.length === 0) return "erDiagram\n";

  const usedTableTokens = new Set();
  const tableAlias = {};
  tableNames.forEach(t => { tableAlias[t] = sanitizeIdentifier(t, usedTableTokens); });

  const pkByTable = {};
  (primaryKeys || []).forEach(pk => { pkByTable[pk.table] = pk.column; });

  const fkColumnsByTable = {};
  (foreignKeys || []).forEach(fk => {
    if (!fkColumnsByTable[fk.table]) fkColumnsByTable[fk.table] = new Set();
    fkColumnsByTable[fk.table].add(fk.column);
  });

  const lines = ["erDiagram"];

  tableNames.forEach(tableName => {
    const fields = schemaTables[tableName] || [];
    lines.push(`    ${tableAlias[tableName]} {`);
    const usedColumnTokens = new Set();
    fields.forEach(field => {
      const colToken = sanitizeIdentifier(field.name, usedColumnTokens);
      const typeToken = field.type || "any";
      const tags = [];
      if (pkByTable[tableName] === field.name) tags.push("PK");
      if (fkColumnsByTable[tableName]?.has(field.name)) tags.push("FK");
      const tagSuffix = tags.length ? ` ${tags.join(",")}` : "";
      lines.push(`        ${typeToken} ${colToken}${tagSuffix}`);
    });
    lines.push("    }");
  });

  (foreignKeys || []).forEach(fk => {
    if (!tableAlias[fk.table] || !tableAlias[fk.ref_table]) return;
    const label = sanitizeIdentifier(fk.column, new Set());
    lines.push(`    ${tableAlias[fk.ref_table]} ||--o{ ${tableAlias[fk.table]} : "${label}"`);
  });

  return lines.join("\n");
}
